import React, { useCallback, useEffect, useReducer, useState } from "react";
import useRouter, { RouteProp } from "react-simplest-router";
import reducer from "../store/reducer";
import initialState from "../store/state";
import { IState } from "../store/types";
import BattleContext from "./BattleContext";
import BattleScreen from "./BattleScreen";
import BoardScreen from "./BoardScreen";
import MultiplayerScreen from "./MultiplayerScreen";
import WaveCreator from "./MultiplayerScreen/WaveCreator";
import WavesViewer from "./MultiplayerScreen/WavesViewer";
import Selection from "./SelectionScreen";
import TitleScreen from "./TitleScreen";
import { ScreenComponent } from "./types";

const initialRoutes: RouteProp<ScreenComponent>[] = [
  { location: "#title", component: TitleScreen },
  { location: "#multiplayer", component: MultiplayerScreen },
  { location: "#multiplayer-create", component: WaveCreator },
  { location: "#multiplayer-load", component: WavesViewer },
  { location: "#battle", component: BattleScreen },
  { location: "#gambit_selection", component: Selection },
  { location: "#tech_tree", component: BoardScreen }
];

function useChangingRouter(state: IState) {
  const { setRoute, ActiveComponent } = useRouter<ScreenComponent>(
    initialRoutes
  );

  // avoid useEffect re-rendering each time
  const changeRoute = useCallback(
    (newRoute: string) => {
      setRoute(newRoute);
      document.location.hash = newRoute;
    },
    [setRoute]
  );

  useEffect(() => {
    if (document.location.hash !== state.screen.current)
      changeRoute(state.screen.current);
  }, [state.screen, changeRoute]);

  return { ActiveComponent };
}

export default function Screen() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { ActiveComponent } = useChangingRouter(state);

  // A Context is used because settings are used in deeply nested children
  const isFirstTurn = state.turn.battle === 0;
  const [autoBattle, setAutoBattle] = useState(true);
  const settings = { isFirstTurn, autoBattle, setAutoBattle };

  return (
    <div>
      <BattleContext.Provider value={settings}>
        <ActiveComponent dispatch={dispatch} state={state} />
      </BattleContext.Provider>
    </div>
  );
}
